/** one second in milliseconds */
export const ONE_SECOND_IN_MS = 1000;
/** one minute in milliseconds */
export const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * 60;
/** one hour in milliseconds */
export const ONE_HOUR_IN_MS = ONE_MINUTE_IN_MS * 60;
/** one day in milliseconds */
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;
/** one week in milliseconds */
export const ONE_WEEK_IN_MS = ONE_DAY_IN_MS * 7;
/** one month in milliseconds */
export const ONE_MONTH_IN_MS = ONE_DAY_IN_MS * 30;
/** one year in milliseconds */
export const ONE_YEAR_IN_MS = ONE_DAY_IN_MS * 365;

export const ONE_DAY_IN_S = ONE_DAY_IN_MS / ONE_SECOND_IN_MS;
export const ONE_WEEK_IN_S = ONE_WEEK_IN_MS / ONE_SECOND_IN_MS;
export const TWO_WEEKS_IN_S = ONE_WEEK_IN_S * 2;
export const ONE_MONTH_IN_S = ONE_MONTH_IN_MS / ONE_SECOND_IN_MS;
